import React from "react";
import { inject, observer } from "mobx-react";
import { computed } from "mobx";
import * as Yup from "yup";

// @ts-ignore
import { Formik, FormikProps, FormikActions } from "formik";
import { Values } from "Tools/Values";
import { STFormWrapper } from "@src/Components/Ui/STFormWrapper";
import { IValuesStore } from "@src/Stores/Values/types";
import { IManagementStore } from "@src/Stores/Management/types";
import styled from "styled-components";
import FormMultiselect from "@src/Components/Common/FormFields/FormMultiselect/FormMultiselect";
import { Permission } from "@src/Interfaces/Entity/Permission";
import {IAuthStore} from "Stores/Auth/types";

const STFormWrapperPermission = styled(STFormWrapper)`
  && {
    min-height: 120px;
  }
`;

const STFormMultiselect = styled(FormMultiselect)`
  && {
    min-width: 120px;
  }
`;

const personPermissionSchema = Yup.object().shape({
  permission: Yup.array().min(0),
});

interface IProps {
  onSubmit: (values: IPermissionForm, formikActions: FormikActions<IPermissionForm>) => void;
  values?: IValuesStore;
  management?: IManagementStore;
  auth?: IAuthStore;
  personPermissions: string[];
}

export interface IPermissionForm {
  permissions: string[];
}

@inject("values", "management", "auth")
@observer
class ChangePermissionForm extends React.Component<IProps> {
  @computed get personPermissions() {
    if (this.props.personPermissions === null) {
      return [];
    }
    return this.props.personPermissions;
  }
  
  @computed get adminPermissionId() {
    return this.props.values.common["AdminPermissionId"];
  }
  
  @computed get availablePermissions() {
    let positions = this.props.management.activePermissions;
    positions.forEach((item) => {
      if (item.id == this.adminPermissionId && !this.props.auth.isAdmin) {
        item.isDisabledAdminPermission = true;
      }
    })
    return positions;
  }

  render() {
    return (
      <Formik
        initialValues={{ permissions: this.personPermissions }}
        validationSchema={personPermissionSchema}
        onSubmit={this.props.onSubmit}
        render={(formikProps: FormikProps<IPermissionForm>) => (
          <STFormWrapperPermission onSubmit={formikProps.handleSubmit}>
            <STFormMultiselect<IPermissionForm, Permission>
              formikProps={formikProps}
              fieldName="permissions"
              items={this.availablePermissions}
              keyAsTitle="name"
              keyAsValue="id"
              keyAsOptionDisabled={"isDisabledAdminPermission"}
              label={Values.getLocalizationValue("permissions")}
              allowEmpty
            />
            {this.props.children}
          </STFormWrapperPermission>
        )}
      />
    );
  }
}

export default ChangePermissionForm;
